let getToken = () => null;
let refreshToken = () => Promise.reject(new Error("Not initialized"));
let onLogout = () => {};

export const setupInterceptors = (tokenGetter, refreshFn, logoutFn) => {
  getToken = tokenGetter;
  refreshToken = refreshFn;
  onLogout = logoutFn;
};

async function fetchCsrfToken() {
  let csrfToken = localStorage.getItem("CSRF_TOKEN");
  if (!csrfToken) {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_AUTH_API_URL}/api/csrf-token`,
        { credentials: "include" }
      );
      const data = await res.json();
      csrfToken = data.token;
      localStorage.setItem("CSRF_TOKEN", csrfToken);
    } catch (error) {
      console.error("Failed to fetch CSRF token", error);
    }
  }
  return csrfToken;
}

function createClient(baseURL, { skipCsrfForPublic = false } = {}) {
  async function request(method, url, body, config = {}) {
    const fullUrl = `${baseURL}${url}`;
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...config.headers,
    };

    const token = getToken();
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const isPublic = skipCsrfForPublic && url.includes("/auth/public/");
    if (!isPublic) {
      const csrfToken = await fetchCsrfToken();
      if (csrfToken) {
        headers["X-XSRF-TOKEN"] = csrfToken;
      }
    }

    const opts = {
      method,
      headers,
      credentials: "include",
    };
    if (body !== undefined) {
      opts.body = JSON.stringify(body);
    }

    let res = await fetch(fullUrl, opts);

    // Auto-refresh on 401 (skip for public/already-retried)
    if (res.status === 401 && !isPublic && !config._retry) {
      try {
        const newToken = await refreshToken();
        headers["Authorization"] = `Bearer ${newToken}`;
        const retryOpts = { ...opts, headers };
        res = await fetch(fullUrl, retryOpts);
      } catch {
        onLogout();
        const error = new Error("Unauthorized");
        error.response = { status: 401 };
        throw error;
      }
    }

    const text = await res.text();
    let data;
    try {
      data = text ? JSON.parse(text) : null;
    } catch {
      data = text;
    }

    if (!res.ok) {
      const error = new Error(res.statusText);
      error.response = { status: res.status, data };
      throw error;
    }

    return { data, status: res.status, headers: res.headers };
  }

  return {
    get: (url, config) => request("GET", url, undefined, config),
    post: (url, body, config) => request("POST", url, body, config),
    put: (url, body, config) => request("PUT", url, body, config),
    delete: (url, config) => request("DELETE", url, undefined, config),
  };
}

const api_auth = createClient(process.env.REACT_APP_AUTH_API_URL, { skipCsrfForPublic: true });
const api_data = createClient(process.env.REACT_APP_DATA_API_URL);

export { api_auth, api_data };
export default api_auth;
